import types from './types'

const isDoneTyping = {
  type: types.IS_DONE_TYPING_ANIMATION
}

export default {
  isDoneTyping
}
